export default "__VITE_ASSET__CVDprsW2__"